import { Helmet } from "react-helmet-async";
import Categories from "../components/Categories";
import ServiceCollection from "../components/ServiceCollection";

import { SebedimContext } from "../context/Context";
import { useContext } from "react";

const Services = () => {
    const { dil } = useContext(SebedimContext);
  return (
    <div>
      <Helmet>
        <title>Merkez Çaphana | Services</title>
        <meta
          name="description"
          content={
            dil === "tm"
              ? "Çap hyzmatlary"
              : dil === "ru"
                ? "Типография Merkez предлагает профессиональные полиграфические услуги."
                : "Merkez Printing House offers professional printing services."
          }
        />
      </Helmet>
      <div className="mb-[70px] mt-[50px]">
        <Categories center={true} />
      </div>
      {/* =====================================================hyzmatlar======================================================== */}
      <ServiceCollection />
    </div>
  );
};

export default Services;
